import { doc } from 'firebase/firestore'
import type { DocumentReference } from 'firebase/firestore'
import { db } from '../lib/firebase'
import { useFirestoreDoc } from './useFirestore'
import type { ArtistDetails } from '../types'

export function useArtistDetails(artistId: string | null): {
  details: ArtistDetails | null
  loading: boolean
} {
  const ref = artistId
    ? (doc(db, 'artistDetails', artistId) as DocumentReference<ArtistDetails>)
    : null
  const { data, loading } = useFirestoreDoc<ArtistDetails>(ref)

  // A missing doc still means "this artist, no extra details yet" — surface an
  // empty-details placeholder rather than null so consumers can render the shell.
  return {
    details: artistId ? (data ?? { id: artistId }) : null,
    loading,
  }
}
